// services/family.service.ts
import api from "@/services/api";
import { BaseService } from "./base.service";

export interface FamilyListParams {
  filters?: Record<string, any>;
  page?: number;
  pageSize?: number;
  sort?: { key: string; direction: "asc" | "desc" } | null;
}

export interface FamilyListResponse {
  data: any[];
  total: number;
}

export interface GetFamilyMembersParams {
  filters?: Record<string, any>;
  sort?: { key: string; direction: "asc" | "desc" }[];
  page?: number;
  pageSize?: number;
}

export interface FamilyMember {
  _id?: string;
  id?: string;
  family_id: string;
  memberId: string;
  relationship: string;
  member: any; // You can replace 'any' with a Member type if available
}

export interface GetFamilyMembersResponse {
  data: FamilyMember[];
  total?: number;
}

export interface FamilyEntity {
  _id?: string;
  id?: string;
  name: string;
  // Add other fields as needed
}

export class FamilyService extends BaseService {
  constructor() {
    super("/family");
  }

  async updateFamily(id: string, data: Partial<{ name: string }>) {
    // PUT to /family/:id for updating family properties
    const response = await this.put(`/${id}`, data);
    return response;
  }

  async getFamily(): Promise<FamilyEntity> {
    const response = await this.get<FamilyEntity>();
    return response;
  }

  async getSpouse(): Promise<any | null> {
    try {
      const response = await this.get("/spouse");
      const data = response as any;
      if (data && data.id) return data;
      return null;
    } catch {
      return null;
    }
  }

  async getFamilies(params: FamilyListParams): Promise<FamilyListResponse> {
    // POST to /family/getAll with filters, pagination, and sorting in the body
    const response = await this.post<FamilyListResponse>(
      "/members/getAll",
      params
    );
    return response;
  }

  async getFamilyMembers(
    params: GetFamilyMembersParams
  ): Promise<GetFamilyMembersResponse> {
    const response = await this.post<GetFamilyMembersResponse>(
      "/members/getAll",
      params
    );
    return response;
  }

  async removeMemberFromFamily(memberId: string, family_id: string) {
    const response = await this.post<{ success: boolean }>(`/remove/member`, {
      memberId,
      family_id,
    });
    return response;
  }
}

export const familyService = new FamilyService();
